import { useMutation, useQueryClient } from '@tanstack/react-query'
import { v1OrganizationsApi, CreateOrganizationRequest } from '../api'
import { toast } from 'sonner'

export function useCreateOrganization() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (data: CreateOrganizationRequest) =>
      v1OrganizationsApi.createOrganization(data),

    onSuccess: (data) => {
      toast.success(`Organization "${data.displayName}" created successfully`)
      queryClient.invalidateQueries({ queryKey: ['v1', 'organizations'] })
    },

    onError: (error: any) => {
      toast.error(error.response?.data?.detail || 'Failed to create organization')
    }
  })
}
